module.exports = __webpack_public_path__ + "img/maps.a5140e58.png";